function rendersNativeButton(element) {
  return typeof element.type === "string" ? element.type === "button" : true;
}
export {
  rendersNativeButton
};
//# sourceMappingURL=nativeButton.js.map
